module.exports = __webpack_public_path__ + "fonts/HMpangram-Thin.9d1a46af.ttf";